<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('editCommandeAchatBailleur.infoGenerales.theme')">
          <b-input v-model="commandeAchatBailleur.theme">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('editCommandeAchatBailleur.infoGenerales.date')" class="obligatoire">
          <b-datepicker show-week-number
                        nearby-selectable-month-days
                        v-model="commandeAchatBailleur.dateDevisCommande"
                        icon="calendar-today"
                        :editable="true">
          </b-datepicker>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    commandeAchatBailleur: {
      type: Object,
      required: true,
    },
  },
};

</script>
